import { DGDrawingServiceGlobal } from "src/app/Services/DrawingService";
import { AnnotationHorizontalLine } from "../AnnotationHorizontalLine";
import { BusinessDay, UTCTimestamp } from "lightweight-charts";
import { Chart } from "../../Chart";
import { WaveDirection } from "../../WaveComputer";
import { SerieColor } from '../../LineSerie';

export class GLobalLastWaveTracker
{
  public line0: AnnotationHorizontalLine;
  public line1: AnnotationHorizontalLine;

  public constructor(public chart:Chart)
  {
    this.update();
  }

  public update()
  {

    let isLastWaveTracker =  DGDrawingServiceGlobal.drawingService().isLastWaveTracker;

    if(this.line0)
    {
       this.chart.chart.removeSeries(this.line0.horizontalLinesSerie)
       this.line0=null;
    }

    if(this.line1)
    {
       this.chart.chart.removeSeries(this.line1.horizontalLinesSerie);
       this.line1=null;
    }


    let wave = DGDrawingServiceGlobal.drawingService().waveComputer.getLastPernamentWave();
    let color = (wave.direction==WaveDirection.UP)?SerieColor.GTRACKEUP:SerieColor.GTRACKEDOWN;

    if(wave&&isLastWaveTracker)
    {
     this.line0 = new AnnotationHorizontalLine(this.chart, wave.data[1].value, wave.data[1].time as UTCTimestamp, color);
     this.line1 = new AnnotationHorizontalLine(this.chart, wave.data[0].value, wave.data[0].time as UTCTimestamp, color);

    }
  }

}
